import React from "react";
const OtherDetails = () => {
  return (
    <div className="mt-10 font-bold">
      <h1 className="text-primary-red font-Rakkas text-center text-xl font-bold underline">
        Co-Operative Group A/C Details
      </h1>
      {/* cooperative 1 */}
      <div className="">
        <p className="text-primary-red mt-5 text-center text-xl font-bold">
          Co-Operative: <span className="text-primary-blue">1</span>
          (Janachetana Multiple Co-Operative Society Ltd.)
        </p>
        {/* left items details */}
        <div className="mt-10 grid place-content-center">
          {/* cooperative name */}
          <div className="border-primary-blue items-center border-2 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Co-Operative Name
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Janachetana Multiple Co-Operative Society Ltd.
            </p>
          </div>
          {/* branch address */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Branch Address
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Bharatpur-12, Bypass Road, Chitwan
            </p>
          </div>
          {/* A/C Holder Name */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              A/C Holder's Name
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Janak Khadka
            </p>
          </div>
          {/* a/c number */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              A/C Number
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              NS-01-631 (MR-01-775)
            </p>
          </div>
          {/* account type*/}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Account Type
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Normal Saving
            </p>
          </div>
        </div>
      </div>
      {/* cooperative  2*/}
      <div className="mt-10">
        <p className="text-primary-red font-Rakkas mt-5 text-center text-xl font-bold">
          Co-Operative: <span className="text-primary-blue">2</span>
          (Samunnat Saving &amp; Credit Co-Operative Ltd.)
        </p>
        {/* left items details */}
        <div className="mt-10 grid place-content-center">
          {/* cooperative name */}
          <div className="border-primary-blue items-center border-2 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Co-Operative Name
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Samunnat Saving &amp; Credit Co-Operative Ltd.
            </p>
          </div>
          {/* branch address */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Branch Address
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Bharatpur-10, Bal Mandir Road, Chitwan
            </p>
          </div>
          {/* A/C Holder Name */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              A/C Holder's Name
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Janak Khadka (1453)
            </p>
          </div>
          {/* a/c number */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              A/C Number
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              321344/2601129
            </p>
          </div>
          {/* account type*/}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Account Type
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              General Saving
            </p>
          </div>
        </div>
      </div>
      {/* cooperative 3 */}
      <div className="mt-10">
        <p className="text-primary-red font-Rakkas mt-5 text-center text-xl font-bold">
          Co-Operative: <span className="text-primary-blue">3</span>
          (V-Group Saving Fund)
        </p>
        {/* left items details */}
        <div className="mt-10 grid place-content-center">
          {/* cooperative name */}
          <div className="border-primary-blue items-center border-2 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Co-Operative Name
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              V-Group Saving Fund
            </p>
          </div>
          {/* branch address */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Branch Address
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Bharatpur-10, Chaubiskothi, Chitwan
            </p>
          </div>
          {/* A/C Holder Name */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              A/C Holder's Name
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Janak Khadka
            </p>
          </div>
          {/* a/c number */}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              A/C Number
            </p>
            <p className="text-primary-blue border-primary-blue p-2">1212121</p>
          </div>
          {/* account type*/}
          <div className="border-primary-blue items-center border-2 border-t-0 sm:flex">
            <p className="text-primary-red border-primary-blue w-56 p-2 sm:border-r-2">
              Account Type
            </p>
            <p className="text-primary-blue border-primary-blue p-2">
              Monthly Saving
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherDetails;
